module.exports = __webpack_public_path__ + "img/icon-kefu1.13092874.png";